export default {
  title: 'Components/Slider/Slider',
  argTypes: {
    slides: {
      control: 'object',
      description: 'Array of slide data objects with url and type properties',
    },
    interval: {
      control: { type: 'number' },
      description: 'Duration in milliseconds for each image slide (not applicable to videos)',
    },
    autoplay: {
      control: 'boolean',
      description: 'Whether to start automatically',
    },
  },
  
  parameters: {
    docs: {
      description: {
        component: `
# DDA Slider Component

A customizable slider component that supports both images and videos with timer animation, navigation controls, and auto-play capability.

## Basic Usage

\`\`\`html
<dda-slider 
  interval="5000"
  autoplay="true">
</dda-slider>
\`\`\`

## Slide Data Structure

Each slide requires a \`type\` property ('image' or 'video') and a \`url\` property:

\`\`\`js
[
  {
    url: "https://example.com/image1.jpg",
    type: "image"
  },
  {
    url: "https://example.com/video1.mp4",
    type: "video"
  }
]
\`\`\`

## Notes

- The timer animation is only applied to image slides
- Video slides will automatically advance to the next slide when the video ends
- You can pause/play videos using the indicator buttons
`,
      },
    },
  },
};


const Template = (args) => {
  const attributes = Object.entries(args)
    .filter(([key, value]) => value !== undefined && key !== 'slides')
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

  return `
    <dda-slider class="custom-slider" ${attributes}></dda-slider>
    <script>
      document.querySelector('.custom-slider').slides = ${JSON.stringify(args.slides)};
    </script>
  `;
};

export const Default = Template.bind({});
Default.args = {
  slides: [
    {
      url: "https://picsum.photos/800/450?random=1",
      type: "image"
    },
    {
      url: "https://videos.pexels.com/video-files/3195394/3195394-uhd_2560_1440_25fps.mp4",
      type: "video"
    },
    {
      url: "https://picsum.photos/800/450?random=3",
      type: "image"
    }
  ],
  interval: 5000,
  autoplay: true,
};

export const ImagesOnly = Template.bind({});
ImagesOnly.args = {
  slides: [
    {
      url: "https://picsum.photos/800/450?random=1",
      type: "image"
    },
    {
      url: "https://picsum.photos/800/450?random=2",
      type: "image"
    },
    {
      url: "https://picsum.photos/800/450?random=3",
      type: "image"
    }
  ],
  interval: 5000,
  autoplay: true,
};

export const VideosOnly = Template.bind({});
VideosOnly.args = {
  slides: [
    {
      url: "https://videos.pexels.com/video-files/3195394/3195394-uhd_2560_1440_25fps.mp4",
      type: "video"
    },
    {
      url: "https://videos.pexels.com/video-files/5532765/5532765-uhd_1440_2732_25fps.mp4",
      type: "video"
    }
  ],
  interval: 5000,
  autoplay: true,
};